import { onError } from 'apollo-link-error';
import { clientError, serverError } from '../lib/errorReporting';

export const formatError = (errorReporter, error) => {
  const path = error.path && error.path.join('.').replace(/\.\d+\./, '[].');
  errorReporter(`GraphQL: ${path} - ${error.message}`, error);
};

export const clientErrorLink = onError(
  ({ graphQLErrors, operation, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(error => formatError(clientError, error));
    }

    if (networkError) {
      clientError(`${operation.operationName} - ${networkError}`, networkError);
    }
  }
);

export const serverErrorLink = onError(
  ({ graphQLErrors, operation, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(error => formatError(serverError, error));
    }

    if (networkError) {
      serverError(
        `${operation.operationName} - ${networkError.response.status} - ${
          networkError.response.statusText
        }`,
        networkError
      );
    }
  }
);
